import _ from "lodash";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getOrganizationFeedQuery } from "Tooling/modules/ToolingQueries";
import {
  assignBillingTagsToOrganizationMutation,
  createNewBillingTagMutation,
  removeBillingTagsFromOrganizationMutation,
} from "./ManageTagsMutations";
import {
  getFiltersMemoized,
  getIsPaidOrganizationValue,
} from "../../../OrganizationV2Utils";

export const getQueryVariablesForOrganizationFeedQuery = state => {
  const {
    tab,
    toddleBuddy,
    plan,
    transitionFilter,
    regionIds,
    isPaidOrganizationKey,
  } = state.tooling.organizationFilters;
  const searchText = state.tooling.searchString.organizations;
  const memoizedFilters = getFiltersMemoized({
    tab,
    toddleBuddy,
    plan,
    searchText,
    transitionFilter,
    regionIds,
  });
  const { value = undefined } = getIsPaidOrganizationValue({
    isPaidOrganizationKey,
  });

  const filters = {
    ...memoizedFilters,
    isPaidOrganization: value,
  };

  const tagFilters = {
    keys: "BILLING_TAG",
  };

  return { filters, tagFilters };
};

export const assignBillingTagsToOrganization = params => {
  return async (dispatch, getState) => {
    const { orgId, tags } = params;

    const state = getState();

    const variables = getQueryVariablesForOrganizationFeedQuery(state);
    try {
      await client.mutate({
        mutation: assignBillingTagsToOrganizationMutation,
        variables: {
          input: _.map(tags, tag => {
            const { id: tagId } = tag;
            return {
              entityId: orgId,
              entityType: "ORGANIZATION",
              tagId,
            };
          }),
        },
        refetchQueries: [
          {
            query: getOrganizationFeedQuery,
            variables,
          },
        ],
      });
    } catch (e) {
      console.error("e", e);
    }
  };
};

export const removeBillingTagsFromOrganization = params => {
  return async (dispatch, getState) => {
    const { orgId, tags } = params;

    const state = getState();

    const variables = getQueryVariablesForOrganizationFeedQuery(state);
    try {
      await client.mutate({
        mutation: removeBillingTagsFromOrganizationMutation,
        variables: {
          input: _.map(tags, tag => {
            const { id: tagId } = tag;
            return {
              entityId: orgId,
              entityType: "ORGANIZATION",
              tagId,
            };
          }),
        },
        refetchQueries: [
          {
            query: getOrganizationFeedQuery,
            variables,
          },
        ],
      });
    } catch (e) {
      console.error("e", e);
    }
  };
};

export const createNewBillingTag = params => {
  return async (dispatch, getState) => {
    const { tagValue } = params;
    const inputVariables = {
      tagKey: "BILLING_TAG",
      tagValue,
    };

    try {
      const { data } = await client.mutate({
        mutation: createNewBillingTagMutation,
        variables: {
          input: inputVariables,
        },
      });

      const [newTag = {}] = _.get(
        data,
        "platform.upsertEntityTags.response",
        []
      );

      return newTag;
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};
